import { ErrorHandler, Injectable } from '@angular/core';
import { captureException } from '@sentry/browser';
import { environment } from '../environments/environment';

@Injectable()
export class AppErrorHandler implements ErrorHandler {
  public handleError(err: any) {
    if (!environment.production) {
      console.error(err);
    }
    captureException(err.originalError || err);
    throw err;
  }
}
